import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOmega: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconOmega"><Path d="M3.75 19.25C3.75 20.3546 4.64543 21.25 5.75 21.25H7.9375C9.04207 21.25 9.9375 20.3546 9.9375 19.25V17.8896C6.66721 16.99 4.26562 14.0037 4.26562 10.4583C4.26562 6.20114 7.72842 2.75 12 2.75C16.2716 2.75 19.7344 6.20114 19.7344 10.4583C19.7344 14.0037 17.3328 16.99 14.0625 17.8896V19.25C14.0625 20.3546 14.9579 21.25 16.0625 21.25H18.25C19.3546 21.25 20.25 20.3546 20.25 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconOmega;
